import React from "react";
import useOrders from "../hooks/useOrders";

const UserOrdersCount: React.FC = () => {
  const { items } = useOrders();
  return <>{items?.length}</>;
};

export default UserOrdersCount;
